import React from 'react';
export const useClickOutside = () => {
    const ref = React.useRef(null);
    const [hasClickedOutside, setHasClickedOutside] = React.useState(false);
    function handleEvent(e) {
        if (ref && ref.current) {
            if (ref.current.contains(e.target)) {
                setHasClickedOutside(false);
            }
            else {
                setHasClickedOutside(true);
            }
        }
    }
    React.useEffect(() => {
        if (window.PointerEvent) {
            document.addEventListener('pointerdown', handleEvent);
        }
        else {
            document.addEventListener('mousedown', handleEvent);
            document.addEventListener('touchstart', handleEvent);
        }
        return () => {
            if (window.PointerEvent) {
                document.removeEventListener('pointerdown', handleEvent);
            }
            else {
                document.removeEventListener('mousedown', handleEvent);
                document.removeEventListener('touchstart', handleEvent);
            }
        };
    }, []);
    return [ref, hasClickedOutside];
};
